import React from 'react';
import { PlusIcon } from '../../../images';
import styles from './create-box.module.scss';
import { Lang } from 'shared/constants/lang';
import { Tooltip } from '../../core';

const CreateBox = React.memo(function CreateBox({ adminMode, onClick, lang }) {
  if (!adminMode) return null;

  return (
    <div data-key="create-content-box" className={styles.createBox} onClick={onClick}>
      <Tooltip title={lang.ADD}>
        <PlusIcon className={styles.addIcon} onClick={onClick} />
      </Tooltip>
    </div>
  );
});

CreateBox.defaultProps = {
  adminMode: false,
  onClick: () => {},
  lang: Lang.ACTION_BUTTON_TOOLTIPS,
};

export { CreateBox };
